import { render, staticRenderFns } from "./MeuCaderno.vue?vue&type=template&id=0b76f819&scoped=true&"
import script from "./MeuCaderno.vue?vue&type=script&lang=js&"
export * from "./MeuCaderno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b76f819",
  null
  
)

export default component.exports